import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import store from "./redux/store";   // adjust path if yours differs

// import { fetchDefaultItems } from "./redux/slices/DefaultThunks";
// import { fetchReferralsItems } from "./redux/slices/ReferralsThunks";
// import { fetchVendorItems } from "./redux/slices/VendorThunks";
// import { fetchReferralpaymentsItems } from "./redux/slices/ReferralpaymentsThunks";
// import { fetchVendorinvoicesItems } from "./redux/slices/VendorinvoicesThunks";
// import { fetchDisputesItems } from "./redux/slices/DisputesThunks";
// import { fetchWaitlistItems } from "./redux/slices/WaitlistThunks";
import { fetchFaqsItems } from "./redux/slices/FaqsThunks";
// import { fetchBannersItems } from "./redux/slices/BannersThunks";
// import { fetchIndustrysectorcategoriesItems } from "./redux/slices/IndustrysectorcategoriesThunks";
// import { fetchFeaturedvendorsItems } from "./redux/slices/FeaturedvendorsThunks";
// import { fetchVendorrecommendationsItems } from "./redux/slices/VendorrecommendationsThunks";
// import { fetchAdminaccountsItems } from "./redux/slices/AdminaccountsThunks";
// import { fetchMembersItems } from "./redux/slices/MembersThunks";
// import { fetchVendorsonhomeItems } from "./redux/slices/VendorsonhomeThunks";
// import { fetchQueriesItems } from "./redux/slices/QueriesThunks";

export default function StateLogger() {
  const dispatch = useDispatch();
  const [enabled, setEnabled] = useState(false);

  // const defaultItems = useSelector(state => state.default.items);
  // const referralsItems = useSelector(state => state.referrals.items);
  // const vendorItems = useSelector(state => state.vendor.items);
  // const referralpaymentsItems = useSelector(state => state.referralpayments.items);
  // const vendorinvoicesItems = useSelector(state => state.vendorinvoices.items);
  // const disputesItems = useSelector(state => state.disputes.items);
  // const waitlistItems = useSelector(state => state.waitlist.items);
  const faqsItems = useSelector(state => state.faqs.items);
  // const bannersItems = useSelector(state => state.banners.items);
  // const industrysectorcategoriesItems = useSelector(state => state.industrysectorcategories.items);
  // const featuredvendorsItems = useSelector(state => state.featuredvendors.items);
  // const vendorrecommendationsItems = useSelector(state => state.vendorrecommendations.items);
  // const adminaccountsItems = useSelector(state => state.adminaccounts.items);
  // const membersItems = useSelector(state => state.members.items);
  // const vendorsonhomeItems = useSelector(state => state.vendorsonhome.items);
  // const queriesItems = useSelector(state => state.queries.items);

  // toggle on CMD+U (or CTRL+U)
  useEffect(() => {
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "u") {
        setEnabled(prev => !prev);
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);

  // when enabled, dispatch & log
  useEffect(() => {
    if (!enabled) return;
    console.log("🌳 Full Redux Store State:", store.getState());
      // dispatch(fetchDefaultItems());
      // dispatch(fetchReferralsItems());
      // dispatch(fetchVendorItems());
      // dispatch(fetchReferralpaymentsItems());
      // dispatch(fetchVendorinvoicesItems());
      // dispatch(fetchDisputesItems());
      // dispatch(fetchWaitlistItems());
      dispatch(fetchFaqsItems());
      // dispatch(fetchBannersItems());
      // dispatch(fetchIndustrysectorcategoriesItems());
      // dispatch(fetchFeaturedvendorsItems());
      // dispatch(fetchVendorrecommendationsItems());
      // dispatch(fetchAdminaccountsItems());
      // dispatch(fetchMembersItems());
      // dispatch(fetchVendorsonhomeItems());
      // dispatch(fetchQueriesItems());
  }, [enabled, dispatch]);

  if (!enabled) return null;

  return (
    <div style={{
      fontFamily: "monospace",
      padding: 20,
      background: "#222",
      color: "#0f0"
    }}>
      <h2>Redux Slice Data</h2>

      {/* <section>
        <strong>Default:</strong>
        <pre>{JSON.stringify(defaultItems, null, 2)}</pre>
      </section>

      <section>
        <strong>referrals:</strong>
        <pre>{JSON.stringify(referralsItems, null, 2)}</pre>
      </section>

      <section>
        <strong>vendor:</strong>
        <pre>{JSON.stringify(vendorItems, null, 2)}</pre>
      </section>

      <section>
        <strong>referralpayments:</strong>
        <pre>{JSON.stringify(referralpaymentsItems, null, 2)}</pre>
      </section>

      <section>
        <strong>vendorinvoices:</strong>
        <pre>{JSON.stringify(vendorinvoicesItems, null, 2)}</pre>
      </section>

      <section>
        <strong>disputes:</strong>
        <pre>{JSON.stringify(disputesItems, null, 2)}</pre>
      </section> */}

      {/* <section>
        <strong>waitlist:</strong>
        <pre>{JSON.stringify(waitlistItems, null, 2)}</pre>
      </section> */}

      <section>
        <strong>faqs:</strong>
        <pre>{JSON.stringify(faqsItems, null, 2)}</pre>
      </section>
{/* 
      <section>
        <strong>banners:</strong>
        <pre>{JSON.stringify(bannersItems, null, 2)}</pre>
      </section>

      <section>
        <strong>industrysectorcategories:</strong>
        <pre>{JSON.stringify(industrysectorcategoriesItems, null, 2)}</pre>
      </section>

      <section>
        <strong>featuredvendors:</strong>
        <pre>{JSON.stringify(featuredvendorsItems, null, 2)}</pre>
      </section>

      <section>
        <strong>vendorrecommendations:</strong>
        <pre>{JSON.stringify(vendorrecommendationsItems, null, 2)}</pre>
      </section>

      <section>
        <strong>adminaccounts:</strong>
        <pre>{JSON.stringify(adminaccountsItems, null, 2)}</pre>
      </section>

      <section>
        <strong>members:</strong>
        <pre>{JSON.stringify(membersItems, null, 2)}</pre>
      </section>

      <section>
        <strong>vendorsonhome:</strong>
        <pre>{JSON.stringify(vendorsonhomeItems, null, 2)}</pre>
      </section>

      <section>
        <strong>queries:</strong>
        <pre>{JSON.stringify(queriesItems, null, 2)}</pre>
      </section> */}
    </div>
  );
}